import { CpSetupInterface } from '../../../interfaces/dto/setup/cp-setup-interface';
import { CpSetupAuthorizationDetailsModel } from '../setup-authorization-details/cp-setup-authorization-details-model';

export class CpSetupModel implements CpSetupInterface {
  authorization: CpSetupAuthorizationDetailsModel[] = new Array<CpSetupAuthorizationDetailsModel>();
  authorizationType: string = '';
  phones: string[] = new Array<string>();
  register: CpSetupAuthorizationDetailsModel[] = new Array<CpSetupAuthorizationDetailsModel>();
  canSubscribeToAgentArea?: boolean = false;
  authorizationAddress?: string = '';

  constructor(init?: Partial<CpSetupModel>) {
    Object.assign(this, init);
  }
}
